import React from 'react';
import './AboutUs.css';

const teamMembers = [
  {
    name: '🌿 Welcome to Lorevial — The Archive of Ingredient Lore',
    description: 'At Lorevial, each ingredient is more than a nutrient—it’s a vessel of memory, origin, and breath. Here, you can explore the deep lore of vegetables, spices, fruits, grains, pulses, dried relics, dairy, herbs, non-veg, rare “Others,” and even the disappeared kinds. Every entry is a layered story: tracing its ancestral roots, regional flavors, culinary uses, glycemic index, health benefits, drawbacks, and symbolic functions. Whether you are a seeker of healing foods or a curator of forgotten wisdom, Lorevial invites you to understand ingredients not just by data—but by soul.',
  },
  {
    name: '🔥 Ingredient Lore — Search by Name, Discover by Ritual',
    description: 'Our intuitive search lets you find any ingredient by name, unlocking its full narrative arc. But beyond search, you can wander through elemental clusters—earthy legumes, fiery spices, lunar herbs, vanished salts—each curated to evoke ritual, lineage, and healing. Ingredient Lore transforms exploration into ceremony, where facts meet folklore and every detail is a poetic offering. From soil to plate, each entry is designed to be emotionally resonant and technically precise.',
  },
  {
    name: '🥣 Nutrilore — Nutrients as Ritual Calculations',
    
    description: 'Nutrilore is our nutrient oracle—where calories, fats, proteins, carbs, and more are revealed with clarity and reverence. Select multiple ingredients, adjust their gram weights, and watch the nutrient story unfold. It’s not just a calculator—it’s a ritual of understanding what you are truly consuming. Whether you are designing a healing meal or decoding a traditional recipe, Nutrilore helps you balance nourishment with intention, offering transparency and elemental insight.',
    
  },
  {
    name: '🌕 A Living Archive of Culinary Memory',
    
    description: 'Lorevial is more than a tool—it’s a living archive of ecological, cultural, and nutritional wisdom. We honor the quiet labor behind each ingredient, the rituals that shaped its use, and the cycles it belongs to. By clustering ingredients into expressive categories and designing interfaces that breathe with elemental symbolism, we invite users to reconnect with food as story, as medicine, and as legacy. This is not just data—it’s devotion.',

  }
];

const AboutUs = () => {
  return (
    <div className="about-container">
      <div className="header">
        <img src="./Images/Lorevial.png" alt="Lorevial Icon" className="nav-icon" />
        <h1>About LoreVial</h1>
        <button className="home-button" onClick={() => window.location.href = '/'}>Home</button>
      </div>
      <div className="card-grid">
        {teamMembers.map((member, index) => (
          <div className="card" key={index}>
            {member.image && <img src={member.image} alt={member.name} />}
            <h2>{member.name}</h2>
            {member.role && <h4>{member.role}</h4>}
            <p>{member.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutUs;
